export const REPORTING_BASE = '/reporting'

export function reportingReportPath(month?: string | null): string {
  const base = `${REPORTING_BASE}/report`
  if (!month) return base
  return `${base}?month=${encodeURIComponent(month)}`
}

export function reportingMembersPath(month?: string | null): string {
  const base = `${REPORTING_BASE}/members`
  if (!month) return base
  return `${base}?month=${encodeURIComponent(month)}`
}
